"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScatterTooltipData = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/fp/flatMap"));
var fp_1 = tslib_1.__importDefault(require("lodash/fp"));
var orderBy_1 = tslib_1.__importDefault(require("lodash/fp/orderBy"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
exports.getScatterTooltipData = function (data, tooltipXVal, xScale) {
    var dataAtMouseLocation = [];
    data.forEach(function (d) {
        var values = d.values, regressionLine = d.regressionLine, rest = tslib_1.__rest(d, ["values", "regressionLine"]);
        var currentTooltipValue = tslib_1.__assign({}, rest);
        currentTooltipValue.values = d.values.filter(function (v) { return xScale(v.x) === xScale(tooltipXVal); });
        if (currentTooltipValue.values.length) {
            dataAtMouseLocation.push(currentTooltipValue);
        }
    });
    var allUniqueDates = pipe_1.default(flatMap_1.default(get_1.default('values')), fp_1.default.map(function (val) { return d3.timeFormat('%b %Y')(val.intersection); }), fp_1.default.uniq)(dataAtMouseLocation);
    var newTooltipData = pipe_1.default(map_1.default(function (d) {
        var valuesPerDate = [];
        var values = d.values, rest = tslib_1.__rest(d, ["values"]);
        var valuesGroupedByDate = pipe_1.default(get_1.default('values'), fp_1.default.groupBy(function (val) { return d3.timeFormat('%b %Y')(val.intersection); }))(d);
        allUniqueDates.forEach(function (date) {
            if (valuesGroupedByDate[date]) {
                valuesPerDate.push(valuesGroupedByDate[date][0].y);
            }
            else {
                valuesPerDate.push(null);
            }
        });
        return tslib_1.__assign(tslib_1.__assign({}, rest), { values: valuesPerDate });
    }), orderBy_1.default('values[0]', 'desc'))(dataAtMouseLocation);
    return {
        dates: allUniqueDates,
        rows: newTooltipData,
    };
};
